import React from 'react';
import './Alert.css';
import { useTranslation } from 'react-i18next';

const Alert = ({ audioDevices, selectedDevice, onSelect, onClose }) => {
    const { t } = useTranslation();

    return (
        <div className="selectable-alert-container">
            <div className="selectable-alert-body">
                <h2>{t("select_audio_device")}</h2>
                
                <h3>{t('microphones')}</h3>
                <ul>
                    {audioDevices.microphones.map((mic) => (
                        <li
                            key={mic.id}
                            onClick={() => onSelect(mic.id)}
                            className={selectedDevice.microphone === mic.id ? 'selected' : ''}
                        >
                            {mic.name || `Device ${mic.id}`}
                        </li>
                    ))}
                </ul>

                <h3>{t('speakers')}</h3>
                <ul>
                    {audioDevices.speakers.map((speaker) => (
                        <li
                            key={speaker.id}
                            onClick={() => onSelect(speaker.id)}
                            className={selectedDevice.speaker === speaker.id ? 'selected' : ''}
                        >
                            {speaker.name || `Device ${speaker.id}`}
                        </li>
                    ))}
                </ul>

                <button onClick={onClose}>{t('close')}</button>
            </div>
        </div>
    );
};

export default Alert;
